module.exports = __webpack_public_path__ + "img/logoComplete.1fcbeacb.png";